import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY}.${BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.FINANCING_NEEDS}` as const;

export const EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES = {
  RESEARCH_COST: 'researchCost',
  MARKETING_COST: 'marketingCost',
  WORKING_CAPITAL_COST: 'workingCapitalCost',
  EQUIPMENT_COST: 'equipmentCost',
  CONSTRUCTION_COST: 'constructionCost',
  OTHER_COST: 'otherCost',
} as const;

export interface IResearchCost {
  currencyAmount: string;
  percentage: string;
}

export interface IFinancingNeedsExecutiveSummaryForm {
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.RESEARCH_COST]?: IResearchCost;
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.MARKETING_COST]?: IResearchCost;
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.WORKING_CAPITAL_COST]?: IResearchCost;
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.EQUIPMENT_COST]?: IResearchCost;
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.CONSTRUCTION_COST]?: IResearchCost;
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.OTHER_COST]?: IResearchCost;
}

export const financingNeedsExecutiveSummaryInitialValues: IFinancingNeedsExecutiveSummaryForm = {
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.RESEARCH_COST]: {
    currencyAmount: '',
    percentage: '',
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.MARKETING_COST]: {
    currencyAmount: '',
    percentage: '',
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.WORKING_CAPITAL_COST]: {
    currencyAmount: '',
    percentage: '',
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.EQUIPMENT_COST]: {
    currencyAmount: '',
    percentage: '',
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.CONSTRUCTION_COST]: {
    currencyAmount: '',
    percentage: '',
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.OTHER_COST]: {
    currencyAmount: '',
    percentage: '',
  },
};
